import { Injectable } from '@angular/core';
import { StoreBase } from '../../shared/models/bases/storeBase';
import { Business } from '../../shared/models/business';

@Injectable({ providedIn: 'root' })
export class BusinessStore extends StoreBase<Business> {}
